/**
 * Re-export of the canonical CitedText citation system.
 *
 * CitationSource and ConceptSource are structurally identical
 * ({ id, name, url, year? }), so the canonical component serves
 * both consumers without any type unsoundness.
 *
 * @see {@link module:@/components/citations/CitedText} - Canonical implementation
 */
export {
  CitationProvider,
  CitedText,
  useCitationContext,
  useOrderedSources,
} from '@/components/citations/CitedText';
